import * as tslib_1 from "tslib";
import { createAction, createReducer, createSelector, on, props } from '@ngrx/store';
export var setIsDesktop = createAction('[Sidebar] Set Is Desktop', props());
export var openModal = createAction('[Sidebar] Open Modal');
export var closeModal = createAction('[Sidebar] Close Modal');
export var donateClicked = createAction('[Donate] Donate Clicked', props());
export var pdfClicked = createAction('[Reading] PDF Clicked', props());
export var initialState = {
    isDesktop: false,
    modalIsOpen: false,
};
var ɵ0 = function (state, action) { return (tslib_1.__assign({}, state, { isDesktop: action.isDesktop })); }, ɵ1 = function (state) { return (tslib_1.__assign({}, state, { modalIsOpen: true })); }, ɵ2 = function (state) { return (tslib_1.__assign({}, state, { modalIsOpen: false })); };
export var uiReducer = createReducer(initialState, on(setIsDesktop, ɵ0), on(openModal, ɵ1), on(closeModal, ɵ2));
export function reducer(state, action) {
    return uiReducer(state, action);
}
var ɵ3 = function (state) { return state.ui; }, ɵ4 = function (ui) { return ui.modalIsOpen; };
export var selectModalStatus = createSelector(ɵ3, ɵ4);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
